export default __webpack_public_path__ + "static/media/necromancerhead.05573239.png";